import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const SalesCreditNote = () => {
  return (
    <PrintPreferenceTabs type="sales_credit_note"></PrintPreferenceTabs>
  );
};
export default SalesCreditNote;